// extracted by mini-css-extract-plugin
export default {"container":"MiniTableContainer_container__XkkbX","loading":"MiniTableContainer_loading__aJlhm","error":"MiniTableContainer_error__k9KfP"};